export function authHeader() {
    // return authorization header with jwt token
    let token = localStorage.getItem('token');

    if (token) {
        return { 'Authorization': 'Bearer ' + token };
    } else {
        return {};
    }
}

export function authHeaderJson() {
    // return authorization header with jwt token
    let token = localStorage.getItem('token');

    if (token) {
        return { 'Content-Type': 'application/json; charset=utf-8', 'Authorization': 'Bearer ' + token };
    } else {
        return {};
    }
}

export function headerJson() {
    return { 'Content-Type': 'application/json; charset=utf-8' };
}